// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FilterOutIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FilterOutIcon" ref={forwardedRef} {...props}>
      <path d="M13.75 9.3V14l-4.5 3V9.3L4 3h15zm-3 4.897 1.5-1v-4.44L15.797 4.5H7.204l3.547 4.257z" />
      <path d="M1.008 12.758h5.555v-1.516H1.008z" />
    </SvgIcon>
  );
});

/**
 * Filter a wider data set by a specific piece of data. To remove a filter use "XmarkIcon"
 * @public
 */
export const FilterOutIcon = /* @__PURE__ */ Object.assign(
  FilterOutIconComponent,
  { displayName: 'FilterOutIcon' },
);
